import { LIMIT_OF_CHARACTERS } from '~/shared/constants';
import { validate, validator } from '~/shared/helpers/validation-helpers';

const getProfileEmailFormConfig = ({
  t,
  initialValues,
  isFooterReverse = false,
  isFixedActions = false,
}: {
  t: (key: string, options: { ns: string[] }) => string;
}) => {
  const validation = validator({ t });

  return {
    name: 'email',
    pattern: 'basicFormPattern',
    isFooterReverse,
    isFixedActions,
    initialValues,

    position0: {
      title: t('text.email-for-reset-password'),
    },
    position1: {
      formFields: [
        {
          name: 'email',
          required: true,
          label: t('field.email.title'),
          validate: validate([
            validation.required,
            validation.isEmail,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.EMAIL.MIN,
              max: LIMIT_OF_CHARACTERS.EMAIL.MAX,
            }),
          ]),
          type: 'text',
          config: {
            isAutoFocus: true,
          },
        },
      ],
    },
    actions: {
      buttons: [
        isFooterReverse
          ? {
              name: 'submit',
              htmlType: 'submit',
              buttonName: t('button.send'),
              size: 'large',
              className: 'call-to-action-button--purple',
              config: {},
            }
          : {
              name: 'submit',
              htmlType: 'submit',
              className: 'call-to-action-button--purple action-button--full-width',
              buttonName: t('button.send'),
              config: {
                isBlock: true,
              },
            },
      ],
    },
  };
};

export default getProfileEmailFormConfig;
